import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ImoveisPage = lazy(() => import('../pages/imoveis/page'));
const ImovelDetailPage = lazy(() => import('../pages/imovel/page'));
const SobreNosPage = lazy(() => import('../pages/sobre-nos/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminImoveisPage = lazy(() => import('../pages/admin/imoveis/page'));
const AdminFaqPage = lazy(() => import('../pages/admin/faq/page'));
const AdminBlogPage = lazy(() => import('../pages/admin/blog/page'));
const AdminLancamentosPage = lazy(() => import('../pages/admin/lancamentos/page'));
const AdminConfiguracoesPage = lazy(() => import('../pages/admin/configuracoes/page'));
const AdminRastreamentoPage = lazy(() => import('../pages/admin/rastreamento/page'));
const AdminImoveisImportarPage = lazy(() => import('../pages/admin/imoveis/importar/page'));
const AdminUsuariosPage = lazy(() => import('../pages/admin/usuarios/page'));
const AdminTesteCadastroPage = lazy(() => import('../pages/admin/teste-cadastro/page'));
const AdminStorageTestPage = lazy(() => import('../pages/admin/storage-test/page'));
const AdminUpdatePasswordPage = lazy(() => import('../pages/admin/update-password/page'));
const DebugFunctionsPage = lazy(() => import('../pages/admin/debug-functions/page'));
const LancamentoPage = lazy(() => import('../pages/lancamento/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/imoveis',
    element: <ImoveisPage />,
  },
  {
    path: '/imoveis/:id',
    element: <ImovelDetailPage />,
  },
  {
    path: '/sobre-nos',
    element: <SobreNosPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/lancamento',
    element: <LancamentoPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/update-password',
    element: <AdminUpdatePasswordPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/imoveis',
    element: <AdminImoveisPage />,
  },
  {
    path: '/admin/imoveis/importar',
    element: <AdminImoveisImportarPage />,
  },
  {
    path: '/admin/faq',
    element: <AdminFaqPage />,
  },
  {
    path: '/admin/blog',
    element: <AdminBlogPage />,
  },
  {
    path: '/admin/lancamentos',
    element: <AdminLancamentosPage />,
  },
  {
    path: '/admin/configuracoes',
    element: <AdminConfiguracoesPage />,
  },
  {
    path: '/admin/rastreamento',
    element: <AdminRastreamentoPage />,
  },
  {
    path: '/admin/usuarios',
    element: <AdminUsuariosPage />,
  },
  {
    path: '/admin/teste-cadastro',
    element: <AdminTesteCadastroPage />,
  },
  {
    path: '/admin/storage-test',
    element: <AdminStorageTestPage />,
  },
  {
    path: '/debug-functions',
    element: <DebugFunctionsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;